import type { MessengerChatViewSettings } from '@widgets/messenger/types'
import { useWidgetChannels } from '@widgets/messenger/compositions/useWidgetChannels'
import { useWidgetStore } from '@widgets/messenger/stores/useWidgetStore'
import { computed } from '@/composition/vue/compositionApi'
import { WebWidgetChannelType } from '@/data/models/domain/messages/settings/webWidget/types'

export const useWidgetChatViewSettings = () => {
  const { widgetSettings } = useWidgetStore()
  const { channelMap } = useWidgetChannels()

  return computed<MessengerChatViewSettings>(() => {
    const { autoReplyMessage, rejectMessage, isSatisfactionSurveyShown, isHidden, uiSettings } =
      widgetSettings.value.channels[WebWidgetChannelType.CHAT]
    const { offlineMessage } = uiSettings

    return {
      channel: channelMap.value[WebWidgetChannelType.CHAT],
      autoReplyMessage,
      rejectMessage,
      isSatisfactionSurveyShown,
      isHidden,
      offlineMessage,
    } satisfies MessengerChatViewSettings
  })
}
